import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { SideNav } from '../side-nav/side-nav.model';
import { AppShellService } from './app-shell.service';

@Component({
  selector: 'app-app-shell',
  templateUrl: './app-shell.component.html',
  styleUrls: ['./app-shell.component.scss'],
  animations: [
    trigger('expandCollapse', [
      state(
        '',
        style({
          width: '230px'
        })
      ),
      state(
        'expand',
        style({
          width: '230px'
        })
      ),
      state(
        'collapse',
        style({
          width: '60px'
        })
      ),
      transition('expand => collapse', [animate('.1s')]),
      transition('collapse => expand', [animate('.1s')])
    ]),
    trigger('expandCollapseMainContent', [
      state(
        '',
        style({
          marginLeft: '0'
        })
      ),
      state(
        'expand',
        style({
          marginLeft: '230px'
        })
      ),
      state(
        'collapse',
        style({
          marginLeft: '60px'
        })
      ),
      transition('expand => collapse', [animate('.1s')]),
      transition('collapse => expand', [animate('.1s')])
    ]),
    trigger('rotateIcon', [
      state(
        'expand',
        style({
          transform: 'rotate(180deg)'
        })
      ),
      state(
        'collapse',
        style({
          transform: 'none'
        })
      ),
      transition('* => *', [animate('400ms')])
    ])
  ]
})
export class AppShellComponent implements OnInit, OnDestroy {
  sideNavItems: SideNav[] = [];
  subscription = new Subscription();
  menuExpandState = '';
  sideNavCssClass = 'root-side-menu';

  activeMediaQuery = '';
  @Input() homeRouteLink = '';

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    public mediaObserver: MediaObserver,
    private appShellService: AppShellService
  ) {
  }

  ngOnInit() {
    this.menuExpandState = this.mediaObserver.isActive('gt-sm') ? 'expand' : '';

    this.subscription.add(this.mediaObserver.asObservable().subscribe(() => {
      this.menuExpandState = this.mediaObserver.isActive('gt-sm') ? 'expand' : '';
    }));

    this.subscription.add(this.appShellService.onSideNavItems.pipe(
      filter(val => val && !!val.length))
      .subscribe(items => this.sideNavItems = items));
  }

  ngOnDestroy(): void { }

  expandCollapseMenu() {
    this.menuExpandState = this.menuExpandState === 'collapse' ? 'expand' : 'collapse';
    this.changeDetectorRef.detectChanges();
    this.appShellService.changeSideNavToggleEvent({ state: this.menuExpandState, value: this.menuExpandState === 'expand' ? 230 : 60 });
  }

}


